<template>
  <div :class="$style.title">
    <div>События</div>
  </div>
  <div :class="$style.headers">
    <div :class="$style.column">Дата</div>
    <div :class="$style.column">Статус</div>
    <div :class="$style.column">Вид</div>
    <div :class="$style.column">Цель</div>
    <div :class="$style.column">Событие</div>
    <div :class="$style.column">Ответственный</div>
  </div>
  <div :class="$style.eventsContent">
    <div
      @click="$router.push(`/event/${item.id}`)"
      v-for="item in items"
      :key="item.id"
      :class="$style.flex"
    >
      <div :class="$style.row">
        <div :class="$style.column">
          {{ item.date.substr(0, 10).split("-").reverse().join(".") }} /
          {{ item.date.substr(11, 5) }}
        </div>
        <div :class="$style.column">{{ getStatus(item) }}</div>
        <div :class="$style.column">{{ getEvent(item) }}</div>
        <div :class="$style.column">{{ item.purpose }}</div>
        <div :class="$style.column">{{ item.event }}</div>
        <div :class="$style.column">
          {{
            item.responsible_manager.name || item.responsible_manager.username
          }}
        </div>
      </div>

      <img
        v-if="!readonly"
        @click="remove(item.id)"
        src="/icons/delete.svg"
        alt=""
      />
    </div>
  </div>
  <div @click="$router.push('/new-event')" :class="$style.add">
    <div :class="$style.button">
      <img src="/icons/plus.svg" alt="" />
      Добавить событие
    </div>
  </div>
</template>

<script>
import FILTERS from "@/assets/constants/filters.json";
export default {
  props: {
    items: Array,
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      events: FILTERS.events,
      statuses: FILTERS.event_statuses,
    };
  },
  methods: {
    getEvent(item) {
      return this.events.find((i) => i.slug == item.event_type).title;
    },
    getStatus(item) {
      return this.statuses.find((i) => i.slug == item.status).title;
    },
    async remove(id) {
      await this.$store.dispatch("deleteEvent", id);
    },
  },
};
</script>

<style lang="scss" module>
.title {
  @include Subtitle;
  margin: 1.5rem 0 1rem 0;
}
.headers,
.row {
  flex: 1 1 auto;
  display: grid;
  grid-template-columns: 2fr 2.5fr 2.5fr 5fr 5fr 2fr;
  gap: 0.25rem;
  @include Subtitle;
  margin: 0 0 1rem 0;
}
.row {
  margin: 0 0 0.25rem 0;
  cursor: pointer;
  &:last-child {
    margin: 0;
  }
  .column {
    padding: 0.75rem 1rem;
    border-radius: 0.25rem;
    background-color: $bg-secondary;
    @include Body1;
  }
}
.eventsContent {
  max-height: 16rem;
  overflow-y: auto;
  @include scrollbarY;
  .flex {
    display: flex;
    gap: 1rem;
    margin: 0 0 0.25rem 0;
    &:last-child {
      margin: 0;
    }
    img {
      cursor: pointer;
    }
  }
}
.add {
  display: flex;
  justify-content: flex-end;
  margin: 1.5rem 0 0 0;
  .button {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    color: $t-white;
    @include Body2;
    background-color: $main-green;
    border-radius: 6.25rem;
    cursor: pointer;
  }
}
</style>
